import {
  CANDIDATE_COUNT,
  CANDIDATE_COUNT_SUCCESSFUL,
  CANDIDATE_COUNT_FAILED,
  CANDIDATE_SEARCH_COUNT,
  CANDIDATE_SEARCH_COUNT_FAILED,
  CANDIDATE_SEARCH_COUNT_SUCCESSFUL
} from "./actionTypes"

export const candidateCount = user => {
  return {
    type: CANDIDATE_COUNT,
    payload: { user },
  }
}

export const candidateCountSuccessful = user => {
  return {
    type: CANDIDATE_COUNT_SUCCESSFUL,
    payload: user,
  }
}

export const candidateCountFailed = user => {
  return {
    type: CANDIDATE_COUNT_FAILED,
    payload: user,
  }
}
export const candidateSearchCount = user => {
  return {
    type: CANDIDATE_SEARCH_COUNT,
    payload: {user},
  }
}

export const candidateSearchCountSuccessful = user => {
  return {
    type: CANDIDATE_SEARCH_COUNT_SUCCESSFUL,
    payload: user,
  }
}

export const candidateSearchCountFailed = user => {
  return {
    type: CANDIDATE_SEARCH_COUNT_FAILED,
    payload: user,
  }
}
